import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgList = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M9 6l11 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 12l11 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 18l11 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 6l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 12l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 18l0 .01" })
	]
});
export { SvgList as ReactComponent };
